/* Custom Cart Drawer v2
   Rendert den kompletten Warenkorb aus /cart.js (keine Section-Rendering-API, kein Caching-Problem).
   Schwellenwerte/Geschenk-Handles stehen als data-Attribute in snippets/custom-cart-drawer.liquid. */
(function () {
  'use strict';

  var drawer = document.getElementById('custom-cart-drawer');
  if (!drawer || drawer.getAttribute('data-ccd-ready')) return;
  drawer.setAttribute('data-ccd-ready', '1');

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CFG = {
    ship: parseInt(drawer.getAttribute('data-ship'), 10) || 3999,
    tiers: [
      { threshold: parseInt(drawer.getAttribute('data-gift1'), 10) || 4900, handle: drawer.getAttribute('data-gift1-handle') || '' },
      { threshold: parseInt(drawer.getAttribute('data-gift2'), 10) || 9900, handle: drawer.getAttribute('data-gift2-handle') || '' }
    ],
    collection: drawer.getAttribute('data-upsell-collection') || ''
  };
  // Positionen der Kreise in % der Panel-Breite (Start des Balkens, Kreis 1, 2, 3)
  var POS = [8.5, 32, 60.1, 88.1];

  var $ = function (sel) { return drawer.querySelector(sel); };
  var el = {
    empty: $('[data-ccd-empty]'),
    body: $('[data-ccd-body]'),
    notice: $('[data-ccd-notice]'),
    text: $('[data-ccd-progress-text]'),
    fill: $('[data-ccd-fill]'),
    nodes: drawer.querySelectorAll('[data-ccd-node]'),
    items: $('[data-ccd-items]'),
    upsell: $('[data-ccd-upsell]'),
    track: $('[data-ccd-track]'),
    prev: $('[data-ccd-prev]'),
    next: $('[data-ccd-next]'),
    checkout: $('[data-ccd-checkout]'),
    discount: $('[data-ccd-discount]'),
    discountNote: $('[data-ccd-discount-note]')
  };

  var state = { cart: null, upsellSeed: undefined, upsell: [], busy: false, lastFocus: null };
  var giftVariantCache = {};
  var compareCache = {}; // handle -> { variantId: compare_at_price in Cent }

  /* ---------- Helfer ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(cents) {
    return '€' + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function isGift(item) { return !!(item.properties && item.properties._free_gift === 'true'); }
  function giftTier(item) { return String((item.properties && item.properties._gift_tier) || '1'); }
  function realTotal(cart) {
    return cart.items.reduce(function (sum, it) { return isGift(it) ? sum : sum + it.final_line_price; }, 0);
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function toCents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return Math.round(v);
    var s = String(v);
    return s.indexOf('.') > -1 ? Math.round(parseFloat(s) * 100) : parseInt(s, 10) * 100;
  }
  function jsonHeaders() { return { 'Content-Type': 'application/json', Accept: 'application/json' }; }
  var storage = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  };

  var noticeTimer = null;
  function notify(msg) {
    el.notice.textContent = msg;
    el.notice.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { el.notice.hidden = true; }, 5000);
  }

  /* ---------- Cart-API ---------- */
  function getCart() {
    return fetch(ROOT + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function changeLine(key, quantity) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function getGiftVariantId(handle) {
    if (giftVariantCache[handle]) return Promise.resolve(giftVariantCache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw new Error('Geschenk nicht gefunden'); return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (v) giftVariantCache[handle] = v.id;
        return v ? v.id : null;
      })
      .catch(function () { return null; });
  }

  /* Geschenke automatisch hinzufügen / entfernen. Gibt true zurück, wenn der Warenkorb geändert wurde. */
  function syncGifts(cart) {
    var real = realTotal(cart);
    var jobs = [];
    CFG.tiers.forEach(function (tier, i) {
      var tierNo = String(i + 1);
      var dismissKey = 'ccd_dismiss_' + tierNo;
      var qualifies = real >= tier.threshold;
      var present = cart.items.filter(function (it) { return isGift(it) && giftTier(it) === tierNo; })[0];

      if (!qualifies) storage.del(dismissKey);

      if (qualifies && !present && tier.handle && !storage.get(dismissKey)) {
        jobs.push(getGiftVariantId(tier.handle).then(function (variantId) {
          if (!variantId) return false;
          return fetch(ROOT + 'cart/add.js', {
            method: 'POST', headers: jsonHeaders(),
            body: JSON.stringify({ id: variantId, quantity: 1, properties: { _free_gift: 'true', _gift_tier: tierNo } })
          }).then(function (r) { return r.ok; }).catch(function () { return false; });
        }));
      } else if (!qualifies && present) {
        jobs.push(changeLine(present.key, 0).then(function () { return true; }).catch(function () { return false; }));
      }
    });
    if (!jobs.length) return Promise.resolve(false);
    return Promise.all(jobs).then(function (res) { return res.some(Boolean); });
  }

  function refresh(opts) {
    opts = opts || {};
    return getCart().then(function (cart) {
      if (opts.sync === false) return cart;
      return syncGifts(cart).then(function (changed) { return changed ? getCart() : cart; });
    }).then(function (cart) {
      render(cart);
      return cart;
    }).catch(function (err) {
      if (window.console) console.error('Warenkorb konnte nicht geladen werden', err);
    });
  }

  /* ---------- Rendering ---------- */
  function render(cart) {
    state.cart = cart;
    var has = cart.item_count > 0;
    el.empty.hidden = has;
    el.body.hidden = !has;
    updateIcon(cart);
    if (!has) return;
    renderProgress(cart);
    renderItems(cart);
    renderFooter(cart);
    loadUpsell(cart);
  }

  function renderProgress(cart) {
    var real = realTotal(cart);
    var T = [CFG.ship, CFG.tiers[0].threshold, CFG.tiers[1].threshold];

    var p;
    if (real >= T[2]) {
      p = POS[3];
    } else {
      for (var i = 0; i < 3; i++) {
        var lo = i === 0 ? 0 : T[i - 1];
        if (real < T[i]) {
          p = POS[i] + (POS[i + 1] - POS[i]) * Math.max(0, (real - lo) / (T[i] - lo));
          break;
        }
      }
    }
    var pct = ((p - POS[0]) / (POS[3] - POS[0])) * 100;
    pct = Math.max(0, Math.min(100, pct)).toFixed(2);
    el.fill.style.width = pct + '%';

    // Zusätzlich direkt auf der grauen Leiste füllen (inline + !important, damit Theme-CSS es nicht überschreiben kann)
    var accent = (window.getComputedStyle(drawer).getPropertyValue('--ccd-accent') || '').trim() || '#4a2545';
    var track = el.fill.parentNode;
    track.style.setProperty('background-image', 'linear-gradient(' + accent + ',' + accent + ')', 'important');
    track.style.setProperty('background-repeat', 'no-repeat', 'important');
    track.style.setProperty('background-position', 'left center', 'important');
    track.style.setProperty('background-size', pct + '% 100%', 'important');
    track.style.setProperty('transition', 'background-size 0.9s cubic-bezier(0.4,0,0.2,1)', 'important');

    Array.prototype.forEach.call(el.nodes, function (node, idx) {
      var reached = real >= T[idx];
      node.classList.toggle('is-reached', reached);
      node.style.setProperty('background-color', reached ? accent : '#d9d9d9', 'important');
      node.style.setProperty('color', reached ? '#fff' : '#111', 'important');
    });

    var html;
    if (real < T[0]) html = 'Nur noch <strong>' + fmt(T[0] - real) + '</strong> für Gratis Versand!';
    else if (real < T[1]) html = 'Nur noch <strong>' + fmt(T[1] - real) + '</strong> für dein Geschenk!';
    else if (real < T[2]) html = 'Nur noch <strong>' + fmt(T[2] - real) + '</strong> für dein 2. Geschenk!';
    else html = 'Du hast alle Geschenke freigeschaltet!';
    el.text.innerHTML = html;
  }

  var ICON_TRASH = '<svg width="18" height="22" viewBox="0 0 18 22" fill="none" aria-hidden="true"><path d="M1.5 5h15M6.5 5V2.8c0-.4.3-.8.8-.8h3.4c.5 0 .8.4.8.8V5M3.2 5l.9 13.2c0 .9.7 1.6 1.6 1.6h6.6c.9 0 1.6-.7 1.6-1.6L14.8 5M7.2 9v7M10.8 9v7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function itemHtml(item, line) {
    var gift = isGift(item);
    var img = (item.featured_image && item.featured_image.url) || item.image || '';
    var meta = '';
    if (!gift) {
      if (!item.product_has_only_default_variant && item.options_with_values) {
        item.options_with_values.forEach(function (o) {
          meta += '<p class="ccd-item-meta">' + esc(o.name) + ': ' + esc(o.value) + '</p>';
        });
      }
      var props = item.properties || {};
      Object.keys(props).forEach(function (k) {
        if (k === '_free_gift' || k === '_gift_tier' || props[k] === '' || props[k] == null) return;
        var val = typeof props[k] === 'object' ? JSON.stringify(props[k]) : String(props[k]);
        meta += '<p class="ccd-item-meta">' + esc(k.replace(/^_+/, '')) + ': ' + esc(val) + '</p>';
      });
    }
    // Vergleichspreis (durchgestrichen) + echter Preis
    var was = item.original_line_price;
    var cmp = compareCache[item.handle] && compareCache[item.handle][item.variant_id];
    if (!gift && cmp && cmp * item.quantity > was) was = cmp * item.quantity;
    var price = '';
    if (was > item.final_line_price) price += '<s>' + fmt(was) + '</s>';
    price += '<span>' + fmt(item.final_line_price) + '</span>';

    var qty = gift ? '' :
      '<div class="ccd-qty">' +
        '<button type="button" data-ccd-dec aria-label="Weniger">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-ccd-inc aria-label="Mehr">+</button>' +
      '</div>';

    return '<div class="ccd-item" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '" data-gift="' + (gift ? giftTier(item) : '') + '">' +
      '<a class="ccd-item-img" href="' + esc(item.url) + '">' +
        (img ? '<img src="' + esc(sized(img, 170)) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' : '') +
      '</a>' +
      '<div class="ccd-item-info">' +
        '<a class="ccd-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        meta +
        '<div class="ccd-item-price' + (gift ? ' is-gift' : '') + '">' + price + '</div>' +
        qty +
      '</div>' +
      '<button type="button" class="ccd-remove" data-ccd-remove aria-label="Entfernen">' + ICON_TRASH + '</button>' +
    '</div>';
  }

  function renderItems(cart) {
    var html = '';
    // Geschenke zuerst, danach die übrigen Produkte (data-key bleibt die echte Zeile)
    cart.items.forEach(function (it, i) { if (isGift(it)) html += itemHtml(it, i + 1); });
    cart.items.forEach(function (it, i) { if (!isGift(it)) html += itemHtml(it, i + 1); });
    el.items.innerHTML = html;
    loadCompare(cart);
  }

  // Vergleichspreise der Varianten nachladen (cart.js liefert sie nicht) und Zeilen danach neu zeichnen
  var compareLoading = {};
  function loadCompare(cart) {
    var jobs = [];
    cart.items.forEach(function (it) {
      var h = it.handle;
      if (!h || isGift(it) || compareCache[h] || compareLoading[h]) return;
      compareLoading[h] = true;
      jobs.push(fetchJson(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (p) {
        var map = {};
        (p.variants || []).forEach(function (v) { map[v.id] = toCents(v.compare_at_price); });
        compareCache[h] = map;
      }).catch(function () { compareCache[h] = {}; }));
    });
    if (!jobs.length) return;
    Promise.all(jobs).then(function () {
      if (state.cart) {
        var html = '';
        state.cart.items.forEach(function (it, i) { if (isGift(it)) html += itemHtml(it, i + 1); });
        state.cart.items.forEach(function (it, i) { if (!isGift(it)) html += itemHtml(it, i + 1); });
        el.items.innerHTML = html;
      }
    });
  }

  function renderFooter(cart) {
    el.checkout.textContent = 'Sicher zur Kasse • ' + (cart.total_price / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';

    // Rabattcode-Hinweis (nur bei echten Rabattcodes)
    var codes = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.type === 'discount_code') codes[d.title] = (codes[d.title] || 0) + (d.total_allocated_amount || 0);
    });
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (app.type === 'discount_code') codes[app.title] = (codes[app.title] || 0) + (a.amount || 0);
      });
    });
    var names = Object.keys(codes);
    var tried = storage.get('ccd_discount_try');
    if (names.length) {
      el.discountNote.className = 'ccd-discount-note is-ok';
      el.discountNote.textContent = 'Rabattcode ' + names.join(', ') + ' angewendet' + (codes[names[0]] ? ' (−' + fmt(codes[names[0]]) + ')' : '');
      el.discountNote.hidden = false;
      storage.del('ccd_discount_try');
    } else if (tried) {
      el.discountNote.className = 'ccd-discount-note';
      el.discountNote.textContent = 'Der Code „' + tried + '“ konnte nicht angewendet werden.';
      el.discountNote.hidden = false;
      storage.del('ccd_discount_try');
    } else {
      el.discountNote.hidden = true;
    }
  }

  /* ---------- Warenkorb-Icon im Header ---------- */
  function updateIcon(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (n) {
      n.textContent = cart.item_count;
    });
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var hasBubble = !!link.querySelector('.cart-count-bubble');
    if ((cart.item_count > 0) === hasBubble) return;
    fetch(ROOT + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['cart-icon-bubble'] || '', 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) link.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Upsell ---------- */
  function normalizeProduct(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var img = '';
    if (typeof p.featured_image === 'string') img = p.featured_image;
    else if (p.featured_image && p.featured_image.src) img = p.featured_image.src;
    else if (p.image && p.image.src) img = p.image.src;
    else if (p.images && p.images.length) img = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return {
      id: p.id,
      title: p.title,
      url: p.url || (ROOT + 'products/' + p.handle),
      image: img,
      variants: p.variants.map(function (v) {
        return { id: v.id, title: v.title, price: toCents(v.price), compare: toCents(v.compare_at_price), available: v.available !== false };
      })
    };
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function loadUpsell(cart) {
    var real = cart.items.filter(function (it) { return !isGift(it); });
    var seed = real.length ? real[real.length - 1].product_id : null;

    if (seed === state.upsellSeed && state.upsell.length) { renderUpsell(cart); return; }
    state.upsellSeed = seed;

    var recs = seed
      ? fetchJson(ROOT + 'recommendations/products.json?product_id=' + seed + '&limit=10&intent=related').then(function (j) { return j.products || []; }).catch(function () { return []; })
      : Promise.resolve([]);

    recs.then(function (list) {
      if (list.length || !CFG.collection) return list;
      return fetchJson(ROOT + 'collections/' + encodeURIComponent(CFG.collection) + '/products.json?limit=12')
        .then(function (j) { return j.products || []; }).catch(function () { return []; });
    }).then(function (list) {
      if (seed !== state.upsellSeed) return; // Warenkorb hat sich zwischenzeitlich geändert
      state.upsell = list.map(normalizeProduct).filter(Boolean);
      renderUpsell(state.cart || cart);
    });
  }

  function cardHtml(p) {
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var multi = p.variants.length > 1;
    var select = '';
    if (multi) {
      select = '<select class="ccd-card-select" data-ccd-variant aria-label="Variante">' +
        p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.id === first.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
            esc(v.title) + (v.available ? '' : ' (ausverkauft)') + '</option>';
        }).join('') + '</select>';
    }
    return '<div class="ccd-card" data-product="' + p.id + '">' +
      '<a class="ccd-card-img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(sized(p.image, 220)) + '" alt="' + esc(p.title) + '" width="100" height="100" loading="lazy">' : '') + '</a>' +
      '<div class="ccd-card-info">' +
        '<div class="ccd-card-title">' + esc(p.title) + '</div>' +
        '<div class="ccd-card-price" data-ccd-card-price>' + priceHtml(first) + '</div>' +
      '</div>' +
      '<div class="ccd-card-actions">' + select +
        '<button type="button" class="ccd-card-add" data-ccd-add' + (first.available ? '' : ' disabled') + '>Hinzufügen</button>' +
      '</div>' +
    '</div>';
  }
  function priceHtml(v) {
    return (v.compare > v.price ? '<s>' + fmt(v.compare) + '</s>' : '') + '<span>' + fmt(v.price) + '</span>';
  }

  function renderUpsell(cart) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var list = state.upsell.filter(function (p) { return !inCart[p.id]; });
    if (!list.length) { el.upsell.hidden = true; el.track.innerHTML = ''; return; }
    el.track.innerHTML = list.map(cardHtml).join('');
    el.upsell.hidden = false;
    el.track.scrollLeft = 0;
    updateArrows();
  }

  function updateArrows() {
    var t = el.track;
    el.prev.disabled = t.scrollLeft <= 2;
    el.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
  }
  el.track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
  window.addEventListener('resize', updateArrows);

  /* ---------- Öffnen / Schließen ---------- */
  function openDrawer() {
    state.lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('.ccd-close');
    if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 50);
    refresh();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      return;
    }
    if (e.target.closest && e.target.closest('[data-ccd-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  }, true);

  // Antippen oder Wischen auf dem abgedunkelten Bereich links neben dem Warenkorb schließt ihn.
  // (iOS Safari löst "click" auf leeren Flächen nur zuverlässig aus, wenn sie direkt einen Listener und cursor:pointer haben.)
  var overlay = drawer.querySelector('.ccd-overlay');
  var panel = drawer.querySelector('.ccd-panel');
  if (overlay) {
    // Abdunkelung + Größe direkt per Inline-Style absichern, falls Theme-CSS sie überschreibt
    overlay.style.setProperty('position', 'absolute', 'important');
    overlay.style.setProperty('top', '0', 'important');
    overlay.style.setProperty('left', '0', 'important');
    overlay.style.setProperty('width', '100%', 'important');
    overlay.style.setProperty('height', '100%', 'important');
    overlay.style.setProperty('background-color', 'rgba(0,0,0,0.4)', 'important');
    overlay.style.setProperty('cursor', 'pointer', 'important');
  }
  // Tipp außerhalb des Warenkorbs (auf der abgedunkelten Fläche) schließt ihn.
  // Wird direkt am Dokument ausgewertet, damit es unabhängig von Overlay-Styling und iOS-Click-Eigenheiten klappt.
  var tapX = 0, tapY = 0, tapMoved = false, tapOutside = false, lastTouchClose = 0;
  function isOpen() { return drawer.classList.contains('is-open'); }
  document.addEventListener('touchstart', function (e) {
    if (!isOpen() || e.touches.length !== 1) { tapOutside = false; return; }
    var t = e.touches[0];
    tapX = t.clientX; tapY = t.clientY; tapMoved = false;
    tapOutside = !(e.target.closest && e.target.closest('.ccd-panel'));
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    if (t && (Math.abs(t.clientX - tapX) > 10 || Math.abs(t.clientY - tapY) > 10)) tapMoved = true;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    if (!isOpen() || !tapOutside || tapMoved) { tapOutside = false; return; }
    tapOutside = false;
    lastTouchClose = Date.now();
    e.preventDefault();
    closeDrawer();
  }, { passive: false, capture: true });
  document.addEventListener('click', function (e) {
    if (!isOpen() || Date.now() - lastTouchClose < 500) return;
    if (e.target.closest && (e.target.closest('.ccd-panel') || e.target.closest('[data-cart-drawer-toggle]'))) return;
    closeDrawer();
  }, true);
  // Nach rechts wischen (auf dem Warenkorb selbst) schließt ihn ebenfalls
  if (panel) {
    var sx = 0, sy = 0, tracking = false;
    panel.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      sx = t.clientX; sy = t.clientY;
      tracking = e.touches.length === 1 && !(e.target.closest && e.target.closest('[data-ccd-track]'));
    }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (dx > 70 && Math.abs(dy) < 50 && dx > Math.abs(dy) * 2) closeDrawer();
    }, { passive: true });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  function mutate(task) {
    if (state.busy) return;
    state.busy = true;
    drawer.classList.add('is-busy');
    Promise.resolve()
      .then(task)
      .then(function () { return refresh(); })
      .catch(function (err) { if (window.console) console.error(err); })
      .then(function () { state.busy = false; drawer.classList.remove('is-busy'); });
  }

  drawer.addEventListener('click', function (e) {
    var t = e.target;
    var item = t.closest('.ccd-item');

    if (item && t.closest('[data-ccd-inc]')) {
      mutate(function () { return changeLine(item.getAttribute('data-key'), parseInt(item.getAttribute('data-qty'), 10) + 1); });
    } else if (item && t.closest('[data-ccd-dec]')) {
      mutate(function () { return changeLine(item.getAttribute('data-key'), Math.max(0, parseInt(item.getAttribute('data-qty'), 10) - 1)); });
    } else if (item && t.closest('[data-ccd-remove]')) {
      var tier = item.getAttribute('data-gift');
      if (tier) storage.set('ccd_dismiss_' + tier, '1'); // entferntes Geschenk nicht sofort wieder hinzufügen
      mutate(function () { return changeLine(item.getAttribute('data-key'), 0); });
    }

    var add = t.closest('[data-ccd-add]');
    if (add) {
      var card = add.closest('.ccd-card');
      var sel = card.querySelector('[data-ccd-variant]');
      var p = state.upsell.filter(function (x) { return String(x.id) === card.getAttribute('data-product'); })[0];
      var variantId = sel ? sel.value : (p && p.variants[0].id);
      if (!variantId) return;
      mutate(function () {
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { notify(j.description || 'Produkt konnte nicht hinzugefügt werden.'); });
        });
      });
    }

    if (t.closest('[data-ccd-prev]')) el.track.scrollBy({ left: -el.track.clientWidth, behavior: 'smooth' });
    if (t.closest('[data-ccd-next]')) el.track.scrollBy({ left: el.track.clientWidth, behavior: 'smooth' });
  });

  drawer.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ccd-variant]');
    if (!sel) return;
    var card = sel.closest('.ccd-card');
    var p = state.upsell.filter(function (x) { return String(x.id) === card.getAttribute('data-product'); })[0];
    var v = p && p.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
    if (!v) return;
    card.querySelector('[data-ccd-card-price]').innerHTML = priceHtml(v);
    card.querySelector('[data-ccd-add]').disabled = !v.available;
  });

  // Rabattcode: Shopify-Standardweg über /discount/CODE, danach Drawer wieder öffnen
  el.discount.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = el.discount.querySelector('input[name="discount"]');
    var code = (input.value || '').trim();
    if (!code) return;
    storage.set('ccd_open_after_discount', '1');
    storage.set('ccd_discount_try', code);
    var path = window.location.pathname + window.location.search;
    window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path);
  });

  // "In den Warenkorb"-Formulare der Produktseiten abfangen und im Drawer öffnen
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var data = new FormData(form);
    // Eingabefelder von Produktoptions-Apps (properties[...]), die außerhalb des <form> stehen, mitsenden
    var scope = form.closest('section, main, .product') || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[name^="properties["]'), function (inp) {
      if (inp.form === form || data.has(inp.name)) return;
      if ((inp.type === 'checkbox' || inp.type === 'radio') && !inp.checked) return;
      if (inp.type === 'file') return;
      if (inp.value !== '') data.append(inp.name, inp.value);
    });
    // Gleiche Anfrage wie der Standard-Button des Themes (/cart/add), damit Apps ihre Daten anhängen können
    var addUrl = (window.routes && window.routes.cart_add_url) || (ROOT + 'cart/add');
    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) {
        if (r.ok) return null;
        return r.json().then(function (j) { return j.description || j.message || 'Produkt konnte nicht hinzugefügt werden.'; });
      })
      .then(function (errMsg) {
        openDrawer();
        if (errMsg) notify(errMsg);
      })
      .catch(function () { openDrawer(); });
  }, true);

  // Zurück-Navigation (bfcache) und Tab-Wechsel: Stand aktualisieren
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  function init() {
    refresh();
    if (storage.get('ccd_open_after_discount')) {
      storage.del('ccd_open_after_discount');
      openDrawer();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
